import { render, staticRenderFns } from "./SpecialtyTable.vue?vue&type=template&id=0038efb4&"
import script from "./SpecialtyTable.vue?vue&type=script&lang=js&"
export * from "./SpecialtyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports